import { useEffect, useRef } from 'react'

import { sendExperimentEvent } from 'Utils/Experiments'

import usePageConfig from './usePageConfig'

const selectServicesLoaded = (config) => Boolean(config?.servicesLoaded)

// The HTML of a first-visit guest is rendered before their UserTrack exists, so without an
// assignment, while /load-services.js may already assign them either arm. Pass renderedVariant as
// null for that HTML: the default page must not report it, or only its own arm would gain those
// views (sample ratio mismatch). The guest is counted from their next page view.
export default function useExperimentExposure({ experimentKey, configKey, renderedVariant }) {
  const isServicesLoaded = usePageConfig({ select: selectServicesLoaded })
  const hasReportedRef = useRef(false)

  useEffect(() => {
    if (!isServicesLoaded || hasReportedRef.current) {
      return
    }

    hasReportedRef.current = true
    const assignedVariant = window.pageConfig?.[configKey]

    if (assignedVariant === renderedVariant) {
      sendExperimentEvent(experimentKey, assignedVariant)
    }
  }, [isServicesLoaded, experimentKey, configKey, renderedVariant])
}
